"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
var react_1 = __importDefault(require("react"));
var View = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M20 10.8333C26.3166 10.8333 31.95 14.3833 34.7 20C31.95 25.6167 26.3333 29.1667 20 29.1667C13.6666 29.1667 8.04996 25.6167 5.29996 20C8.04996 14.3833 13.6833 10.8333 20 10.8333ZM20 7.5C11.6666 7.5 4.54996 12.6833 1.66663 20C4.54996 27.3167 11.6666 32.5 20 32.5C28.3333 32.5 35.45 27.3167 38.3333 20C35.45 12.6833 28.3333 7.5 20 7.5ZM20 15.8333C22.3 15.8333 24.1666 17.7 24.1666 20C24.1666 22.3 22.3 24.1667 20 24.1667C17.7 24.1667 15.8333 22.3 15.8333 20C15.8333 17.7 17.7 15.8333 20 15.8333ZM20 12.5C15.8666 12.5 12.5 15.8667 12.5 20C12.5 24.1333 15.8666 27.5 20 27.5C24.1333 27.5 27.5 24.1333 27.5 20C27.5 15.8667 24.1333 12.5 20 12.5Z", fill: "currentColor" })))); };
exports.View = View;
